// extracted by mini-css-extract-plugin
module.exports = {"future-of-freight":"FutureOfFreight_future-of-freight__4lFgY"};